import styled from "@emotion/styled";
import { APP_BREAKPOINT } from "src/constants/layout";

export const CollectionRow = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  box-sizing: content-box;
  justify-content: space-between;

  padding: 1rem;

  &::after {
    content: "";
    display: block;
    width: calc(100% - 2rem);
    height: 1px;
    background: #0000001a;
    position: absolute;
    top: 100%;
  }

  &:last-of-type::after {
    content: none;
  }

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    padding: 1.4rem;
  }

  .link {
    flex: 1 1 auto;
    padding: 0;

    &::after {
      display: none;
    }

    @media screen and (min-width: ${APP_BREAKPOINT}px) {
      padding: 0;
    }
  }
`;
